import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Loader2, Lock } from "lucide-react";
import { IMG } from "@/data/media";
import { useAuth, formatError } from "@/admin/auth";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-5 py-16 bg-[var(--cream)]">
      <Helmet><title>Area riservata — MADE</title><meta name="robots" content="noindex, nofollow" /><html lang="it" /></Helmet>
      <form onSubmit={submit} className="w-full max-w-md bg-white p-8 sm:p-10 rounded-[2.5rem_2.5rem_2.5rem_0.5rem] shadow-[0_0_0_1px_var(--line),0_30px_60px_-30px_rgba(19,61,42,.35)]" data-testid="admin-login-form">
        <img src={IMG.logo} alt="Logo MADE" className="h-16 w-auto" />
        <p className="eyebrow mt-8">Area riservata</p>
        <h1 className="mt-3 text-4xl">Accedi</h1>
        <label htmlFor="admin-email" className="block mt-8 text-sm font-semibold">Email</label>
        <input id="admin-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full rounded-2xl bg-[var(--cream)] px-4 py-3.5 outline-none shadow-[inset_0_0_0_1.5px_var(--line)] focus:shadow-[inset_0_0_0_2px_var(--green-deep)]" data-testid="admin-email-input" />
        <label htmlFor="admin-password" className="block mt-5 text-sm font-semibold">Password</label>
        <input id="admin-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full rounded-2xl bg-[var(--cream)] px-4 py-3.5 outline-none shadow-[inset_0_0_0_1.5px_var(--line)] focus:shadow-[inset_0_0_0_2px_var(--green-deep)]" data-testid="admin-password-input" />
        {error && <p role="alert" className="mt-5 rounded-2xl bg-[var(--coral-pale)] p-3 text-sm text-[#7a1d14]" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn btn-primary w-full mt-8 disabled:opacity-70" data-testid="admin-login-submit">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Lock size={16} />} Accedi
        </button>
      </form>
    </div>
  );
}
